import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTree: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTree"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C7.02944 2 3 6.02944 3 11C3 15.6326 6.50005 19.4476 11 19.9451V22H13V19.9451C17.5 19.4476 21 15.6326 21 11C21 6.02944 16.9706 2 12 2ZM11 17.9291V15.4142L8.58579 13L10 11.5858L12 13.5858L15 10.5858L16.4142 12L13 15.4142V17.9291C12.6734 17.9758 12.3395 18 12 18C11.6605 18 11.3266 17.9758 11 17.9291Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTree;
